import { get } from 'lodash';
import { REHYDRATE } from 'redux-persist/constants';

import createReducer from '../../helpers/CreateReducer';
import { ApiConstants } from '../../constants/actions';

interface Error {
  name: string;
  code: string;
  message: string;
}

interface VoucherOrderState {
  lastPaymentPublicId: string | null;
  isError: boolean;
  isNewCustomer: boolean;
  rehydrated?: boolean;
  errors?: Error[];
}

interface ActionPayload {
  payload?: {
    paymentPublicId?: string;
  };
  isNewCustomer?: boolean;
}

interface RehydrateAction {
  payload: {
    apiVoucherOrder: Partial<VoucherOrderState>;
  };
}

export const getInitialState = (): VoucherOrderState => ({
  lastPaymentPublicId: null,
  isError: false,
  isNewCustomer: false
});

export default createReducer(getInitialState, {
  [`${ApiConstants.CREATE_VOUCHER_ORDER}_CLEAR`]:
    (): Partial<VoucherOrderState> => ({
      lastPaymentPublicId: null,
      isError: false
    }),
  [`${ApiConstants.CREATE_VOUCHER_ORDER}_SUCCESS`]: (
    state: VoucherOrderState,
    { payload, isNewCustomer }: ActionPayload
  ): Partial<VoucherOrderState> => ({
    lastPaymentPublicId: get(payload, 'paymentPublicId') || null,
    errors: [],
    isError: false,
    isNewCustomer: !!isNewCustomer
  }),
  [`${ApiConstants.CREATE_VOUCHER_ORDER}_FAILURE`]:
    (): Partial<VoucherOrderState> => ({
      lastPaymentPublicId: null,
      isError: true
    }),
  [`${REHYDRATE}`]: (
    state: VoucherOrderState,
    action: RehydrateAction
  ): VoucherOrderState => ({
    ...state,
    ...action.payload.apiVoucherOrder,
    rehydrated: true
  })
});
